/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".white-space-wrap[_ngcontent-%COMP%]{white-space:normal;font-family:Opensans-Regular;cursor:text}.msg-body[_ngcontent-%COMP%]{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:16px;font-weight:400}.msg-title[_ngcontent-%COMP%]{font-family:Pru-Modern SemiCond,Arial,Helvetica Neue,Helvetica,sans-serif;font-size:30px;font-weight:600;color:#000}.form-control[_ngcontent-%COMP%]{border:1px solid #707070}.has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ee0006;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}"];
export { styles as styles };
